import React, { useState } from 'react';

// Shares StaffInput's SVG coordinates so every answer stays below its chord.
export default function TriadAnalysisRows({ startX, slotWidth, value, onChange, mode, feedback }) {
  const [focused, setFocused] = useState(null);
  function update(group, slot, text) {
    if (mode === 'edit') onChange({ ...value, [group]: { ...(value[group] || {}), [slot]: text } });
  }
  const rows = [
    { group: 'romanNumerals', label: 'C. Scale Degree:', top: 188, width: 82 },
    { group: 'degreeNames', label: 'D. Name of Scale Degree: Tonic, etc.', top: 296, width: slotWidth - 12 }
  ];
  return <g>
    {mode === 'review' && Array.from({ length: 8 }, (_, i) => i + 1).map(slot => {
      const part = feedback?.parts?.[slot];
      return part ? <rect key={`triad-${slot}`} x={startX + (slot - 1) * slotWidth + 3}
        y={28} width={slotWidth - 6} height={86} fill="none" pointerEvents="none"
        stroke={part.correct ? '#2e7d32' : '#c62828'} strokeWidth={2} /> : null;
    })}
    {rows.map(row => <g key={row.group}>
      <text x={startX} y={row.top - (row.group === 'romanNumerals' ? 36 : 12)} fontSize={14} fill="#000">{row.label}</text>
      {row.group === 'romanNumerals' && <text x={startX} y={row.top - 16} fontSize={14} fill="#000">
        Use <tspan fontWeight="bold">Roman numerals</tspan>.
      </text>}
      {Array.from({ length: 8 }, (_, i) => i + 1).map(slot => {
        const id = `${row.group}-${slot}`;
        const part = feedback?.parts?.[row.group]?.[slot];
        return <foreignObject key={slot} x={startX + (slot - 1) * slotWidth + (slotWidth - row.width) / 2}
          y={row.top} width={row.width} height={row.group === 'romanNumerals' ? 76 : 72}>
          <div xmlns="http://www.w3.org/1999/xhtml">
            <input type="text" aria-label={`${row.label}, scale degree ${slot === 8 ? '8 (tonic)' : slot}`}
              value={value[row.group]?.[slot] || ''} disabled={mode !== 'edit'}
              autoCapitalize="none" autoComplete="off" spellCheck={false}
              onFocus={() => setFocused(id)} onBlur={() => setFocused(current => current === id ? null : current)}
              onChange={e => update(row.group, slot, e.target.value)}
              style={{ width: '100%', height: 32, boxSizing: 'border-box', textAlign: 'center',
                fontSize: 15, color: '#000', background: '#fff', borderRadius: 4,
                border: mode === 'review' && part ? `2px solid ${part.correct ? '#2e7d32' : '#c62828'}` : '1px solid #888' }} />
            {row.group === 'degreeNames' && <div aria-hidden="true" style={{ height: 20, lineHeight: '20px', textAlign: 'center', fontSize: 14, color: '#000' }}>
              {slot === 8 ? '1 (8)' : slot}
            </div>}
            {row.group === 'romanNumerals'  && focused === id && mode === 'edit' &&
              <div style={{ display: 'flex', gap: 4, marginTop: 4 }}>
                {[['°', 'degree sign'], ['+', 'plus sign']].map(([symbol, name]) =>
                  <button type="button" key={symbol} tabIndex={-1} aria-label={`Insert ${name} for degree ${slot}`}
                    style={{ padding: '2px 7px', fontSize: 16 }}
                    onPointerDown={e => { e.preventDefault(); e.stopPropagation(); update(row.group, slot, (value[row.group]?.[slot] || '') + symbol); }}>{symbol}</button>)}
              </div>}
            {mode === 'review' && part && !part.correct && <div style={{ fontSize: 12, color: '#b71c1c' }}>{part.expected}</div>}
          </div>
        </foreignObject>;
      })}
    </g>)}
  </g>;
}
